<template>
  <div>
    <v-data-table
      class="elevation-1"
      :headers="cabeceras"
      :items="documentos"
      :loading="cargando"
      :server-items-length="totalItems"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, 200],
      }"
      dense
      @update:page="$emit('cargar-datos')"
      @update:items-per-page="$emit('actualizar-items-por-pagina', $event)">
      <template v-slot:[`header.documentos`]>
        <v-simple-table dense>
          <thead>
            <tr>
              <th style="width: 210px; border-bottom: none"></th>
              <th style="width: 200px; border-bottom: none">Tipo de Documento</th>
              <th style="width: 100px; border-bottom: none">Requiere Validación</th>
              <th style="width: 150px; border-bottom: none">Estado de Revisión</th>
              <th style="width: 150px; border-bottom: none">Fecha de Remplazo</th>
              <th style="width: 300px; border-bottom: none">Observaciones</th>
              <th style="width: 150px; border-bottom: none">Fecha de Vencimiento</th>
              <th style="width: 300px; border-bottom: none">Subido Por</th>
              <th style="width: 300px; border-bottom: none">Revisado Por</th>
            </tr>
          </thead>
        </v-simple-table>
      </template>

      <template v-slot:[`item.estudiante`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>
                {{
                  concatenar(item.estudiante.nombres, item.estudiante.primerApellido, item.estudiante.segundoApellido)
                }}
              </v-list-item-title>

              <v-list-item-subtitle> {{ item.estudiante.numeroDocumento }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.programa`]="{ item }">
        <v-list class="py-0" color="transparent" dense three-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>{{ item.programa.nombreCompuesto }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ `${item.programa.codigo} (ID.: ${item.programa.id})` }}
              </v-list-item-subtitle>
              <v-list-item-subtitle> {{ item.programa.sede.nombre }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.programaUniversidad`]="{ item }">
        <v-list class="py-0" color="transparent" dense three-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.programa?.programaUniversidad?.programaNombre || '-' }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.programa?.programaUniversidad?.codigo || '-' }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.programa?.programaUniversidad?.sedeUniversidad?.nombre || '-' }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.documentos`]="{ item }">
        <v-simple-table dense>
          <tbody>
            <tr
              v-for="inscripcionDocumentoPersona in item.inscripcionesDocumentosPersonas"
              :key="inscripcionDocumentoPersona.id"
              :style="{ backgroundColor: inscripcionDocumentoPersona.eliminadoEn ? '#ffebee' : 'transparent' }">
              <td style="width: 210px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="primary"
                      @click="
                        $router.push({
                          name: 'documentos-inscripciones-ver',
                          params: { id: inscripcionDocumentoPersona.id },
                        })
                      ">
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>

                  <span>Ver Detalle</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="primary"
                      @click="$refs.modalPrevisualizacionRef.abrir(inscripcionDocumentoPersona.id)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>

                  <span>Previsualizar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="
                        !!inscripcionDocumentoPersona.eliminadoEn ||
                        inscripcionDocumentoPersona.documentoPersona.estadoRevision !==
                          estadosRevisionDocumentoInscripcion.RECHAZADO
                      "
                      icon
                      small
                      @click="$refs.reemplazarInscripcionDocumentoPersonaRef.abrir(inscripcionDocumentoPersona.id)">
                      <v-icon>mdi-file-replace</v-icon>
                    </v-btn>
                  </template>

                  <span>Reemplazar Documento</span>
                </v-tooltip>
              </td>

              <td style="width: 200px">
                <v-list class="py-0" color="transparent" dense two-line>
                  <v-list-item class="px-0" dense>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">
                        {{ inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.nombre }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{
                          propositosTiposDocumentosPersonaTextos[
                            inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.proposito
                          ]
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </td>

              <td style="width: 100px">
                <v-chip
                  :color="
                    getRequireValidacionColor(
                      inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.requiereValidacion,
                    )
                  "
                  small
                  dark>
                  {{
                    inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.requiereValidacion ? 'Sí' : 'No'
                  }}
                </v-chip>
              </td>

              <td style="width: 150px">
                <v-chip
                  v-if="inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.requiereValidacion"
                  :color="getEstadoRevisionColor(inscripcionDocumentoPersona.documentoPersona.estadoRevision)"
                  small
                  dark>
                  {{ inscripcionDocumentoPersona.documentoPersona.estadoRevision }}
                </v-chip>

                <span style="font-size: 13px" v-else>N/A</span>
              </td>

              <td style="width: 150px">
                {{ formatearFecha(inscripcionDocumentoPersona.eliminadoEn) || '-' }}
              </td>

              <td style="width: 300px" class="text-caption">
                {{ inscripcionDocumentoPersona.documentoPersona.observaciones || '-' }}
              </td>

              <td
                v-if="inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.aplicaFechaVencimiento"
                style="width: 150px">
                {{
                  inscripcionDocumentoPersona.documentoPersona.esIndefinido
                    ? 'Indefinido'
                    : inscripcionDocumentoPersona.documentoPersona.fechaVencimiento
                }}
              </td>

              <td v-else style="width: 150px">-</td>

              <td style="width: 300px">
                <v-list class="py-0" color="transparent" dense two-line>
                  <v-list-item class="px-0" dense>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        inscripcionDocumentoPersona.documentoPersona.subidoPor
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ formatearFecha(inscripcionDocumentoPersona.documentoPersona.creadoEn) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </td>

              <td style="width: 300px">
                <v-list class="py-0" color="transparent" dense two-line>
                  <v-list-item class="px-0" dense>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{
                          inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.requiereValidacion
                            ? inscripcionDocumentoPersona.documentoPersona.revisadoPor || '-'
                            : 'N/A'
                        }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{
                          inscripcionDocumentoPersona.documentoPersona.tipoDocumentoPersona.requiereValidacion
                            ? inscripcionDocumentoPersona.documentoPersona.fechaHoraRevision
                              ? formatearFecha(inscripcionDocumentoPersona.documentoPersona.fechaHoraRevision)
                              : '-'
                            : 'N/A'
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
    </v-data-table>

    <ModalPrevisualizacion ref="modalPrevisualizacionRef" />

    <ReemplazarInscripcionDocumentoPersona
      ref="reemplazarInscripcionDocumentoPersonaRef"
      @documento-reemplazado="$emit('actualizar-lista')" />
  </div>
</template>

<script>
import { PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS } from '../../../comisiones/utils/constantes';
import { ESTADOS_REVISION_DOCUMENTO_INSCRIPCION } from '../utils';
import ModalPrevisualizacion from './ModalPrevisualizacion.vue';
import ReemplazarInscripcionDocumentoPersona from './ReemplazarInscripcionDocumentoPersona.vue';

export default {
  name: 'DataTableDocumentosInscripcionesAgrupado',
  components: {
    ModalPrevisualizacion,
    ReemplazarInscripcionDocumentoPersona,
  },
  props: {
    documentos: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPorPagina: {
      type: Number,
      required: true,
    },
    pagina: {
      type: Number,
      required: true,
    },
  },
  computed: {
    page: {
      get() {
        return this.pagina;
      },
      set(value) {
        this.$emit('update:pagina', value);
      },
    },
    itemsPerPage: {
      get() {
        return this.itemsPorPagina;
      },
      set(value) {
        this.$emit('update:itemsPorPagina', value);
      },
    },
  },
  data() {
    return {
      cabeceras: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Estudiante', value: 'estudiante', sortable: false, width: 300 },
        { text: 'Documentos', value: 'documentos', sortable: false, width: 1710 },
        { text: 'Programa', value: 'programa', sortable: false },
        { text: 'Categoría', value: 'programa.postgrado.categoria.nombre', sortable: false },
        { text: 'Programa Universidad', value: 'programaUniversidad', sortable: false },
      ],
      propositosTiposDocumentosPersonaTextos: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS,
      estadosRevisionDocumentoInscripcion: ESTADOS_REVISION_DOCUMENTO_INSCRIPCION,
    };
  },
  methods: {
    getEstadoRevisionColor(estado) {
      const colores = {
        pendiente: 'orange',
        aprobado: 'success',
        rechazado: 'error',
      };

      return colores[estado] || 'grey';
    },
    getRequireValidacionColor(requiereValidacion) {
      return requiereValidacion ? 'green' : 'red';
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return '';
      }

      return new Date(fecha).toLocaleString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    concatenar(...args) {
      return args.filter((arg) => arg).join(' ');
    },
  },
};
</script>